export default __webpack_public_path__ + "static/Comfortaa-89334e296b0006fb48cffac03eb5022b.woff2";